import { render, staticRenderFns } from "./AfterSale.vue?vue&type=template&id=51048af6&"
import script from "./AfterSale.vue?vue&type=script&lang=js&"
export * from "./AfterSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports